// errorHandler.js
export function handleErrorResponse(error) {
    let messages = [];

    if (error.response && error.response.data && typeof error.response.data === 'object') {
        if (error.response.data.message) {
            messages.push(error.response.data.message);
        }

        if (error.response.data.errors) {
            for (const [field, fieldErrors] of Object.entries(error.response.data.errors)) {
                messages.push(`${field}: ${fieldErrors.join(', ')}`);
            }
        }
    } else {
        messages.push('An unexpected error occurred.');
    }

    return messages.join('\n');
}
